(function () {
  if (customElements.get('cart-drawer-recommendations')) return;

  class CartDrawerRecommendations extends HTMLElement {
    constructor() {
      super();
      this.sectionId = this.dataset.sectionId;
      this.lastSeedId = null;
    }

    connectedCallback() {
      this.refresh();
      this.observeCart();
    }

    observeCart() {
      const target = document.querySelector('#CartDrawer, cart-drawer');
      if (!target) return;
      this.cartObserver = new MutationObserver(() => this.refresh());
      this.cartObserver.observe(target, { childList: true, subtree: true, attributes: true, attributeFilter: ['class'] });
    }

    async fetchRecommendations(seedProductId, intent) {
      const url = '/recommendations/products?product_id=' + seedProductId + '&section_id=' + this.sectionId + '&intent=' + intent + '&limit=6';
      const res = await fetch(url);
      if (!res.ok) return null;
      const html = await res.text();
      if (html.indexOf('data-recommendation-product-id') === -1) return null;
      return html;
    }

    async refresh() {
      try {
        const cartRes = await fetch('/cart.js');
        const cart = await cartRes.json();

        if (!cart.items || cart.items.length === 0) {
          this.innerHTML = '';
          return;
        }

        const cartProductIds = new Set(cart.items.map((item) => item.product_id));
        const seedProductId = cart.items[cart.items.length - 1].product_id;

        let html = await this.fetchRecommendations(seedProductId, 'complementary');
        if (!html) html = await this.fetchRecommendations(seedProductId, 'related');
        if (!html) { this.innerHTML = ''; return; }

        const parser = new DOMParser();
        const doc = parser.parseFromString(html, 'text/html');
        doc.querySelectorAll('[data-recommendation-product-id]').forEach((item) => {
          const id = parseInt(item.dataset.recommendationProductId, 10);
          if (cartProductIds.has(id)) item.remove();
        });

        if (doc.querySelectorAll('[data-recommendation-product-id]').length === 0) {
          this.innerHTML = '';
          return;
        }

        this.innerHTML = doc.body.innerHTML;
        this.lastSeedId = seedProductId;
        this.bindAddButtons();
      } catch (err) {
        console.error('cart-drawer-recommendations', err);
      }
    }

    bindAddButtons() {
      this.querySelectorAll('[data-recommendation-add]').forEach((button) => {
        button.addEventListener('click', async (event) => {
          event.preventDefault();
          const variantId = button.dataset.variantId;
          button.setAttribute('disabled', 'disabled');
          try {
            const addRes = await fetch('/cart/add.js', {
              method: 'POST',
              headers: { 'Content-Type': 'application/json' },
              body: JSON.stringify({ items: [{ id: variantId, quantity: 1 }] }),
            });
            if (!addRes.ok) throw new Error('add failed');

            const sectionRes = await fetch(window.location.pathname + '?section_id=cart-drawer');
            const html = await sectionRes.text();
            const doc = new DOMParser().parseFromString(html, 'text/html');
            const newDrawer = doc.querySelector('cart-drawer');
            const oldDrawer = document.querySelector('cart-drawer');
            if (newDrawer && oldDrawer) {
              oldDrawer.innerHTML = newDrawer.innerHTML;
              oldDrawer.classList.add('active', 'animate');
              document.body.classList.add('overflow-hidden');
            }
          } catch (err) {
            button.removeAttribute('disabled');
          }
        });
      });
    }
  }

  customElements.define('cart-drawer-recommendations', CartDrawerRecommendations);
})();
